import _get from 'lodash/get';
import _isNil from 'lodash/isNil';

import { PROVIDER_ENTITY_ATTRIBUTE_STATUS } from 'components/modules/business-profile/constants/provider-entity-attributes';

import { ACTION_SET, ACTION_DELETE } from './BusinessInfoTab.constants';

export function getNextStatus(action, placeAction) {
  const { sourceId: previousSourceId } = placeAction || {};
  const existsInRemote = !_isNil(previousSourceId);

  let status;
  if (action === ACTION_SET) {
    status = existsInRemote
      ? PROVIDER_ENTITY_ATTRIBUTE_STATUS.TO_UPDATE
      : PROVIDER_ENTITY_ATTRIBUTE_STATUS.TO_CREATE;
  }
  if (action === ACTION_DELETE) {
    status = existsInRemote
      ? PROVIDER_ENTITY_ATTRIBUTE_STATUS.TO_DELETE
      : PROVIDER_ENTITY_ATTRIBUTE_STATUS.DO_NOTHING;
  }

  return status;
}

export function getNextPayload(action, newData = {}, placeAction) {
  const { attributes: previousAttributes = {} } = placeAction || {};
  const status = getNextStatus(action, placeAction);

  let payload = { status };

  if (action === ACTION_SET) {
    const { uri, pageId, isPreferred } = newData;

    const attributes = {
      ...previousAttributes,
      uri,
      isPreferred,
    };

    payload = { ...payload, objectId: _isNil(pageId) ? null : pageId, attributes };
  }

  if (action === ACTION_DELETE) {
    const attributes = {
      ...previousAttributes,
      uri: '',
      isPreferred: false,
    };

    payload = { ...payload, objectId: null, attributes };
  }

  return payload;
}

export function filterGoogleConfiguredLocations(location, locationSettings) {
  const locationId = _get(location, 'id');
  return locationSettings.some(
    (setting) => _get(setting, 'serviceData.fishermanLocationId') === locationId,
  );
}
